import BusinessRegistrationPeriodService from '../services/business-registration-period-service';

export const businessRegistrationPeriod = {
  namespaced: true,
  state: {
    periods: null,
    suspensions: null,
  },
  actions: {
    getBusinessRegistrationPeriodList({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setPeriods', null);
      return BusinessRegistrationPeriodService.getBusinessRegistrationPeriodList(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setPeriods', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getBusinessRegistrationSuspensionList({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setSuspensions', null);
      return BusinessRegistrationPeriodService.getBusinessRegistrationSuspensionList(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setSuspensions', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createPeriod({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationPeriodService.createPeriod(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    addBusinessRegistrationSuspension({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationPeriodService.addBusinessRegistrationSuspension(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    liftBusinessRegistrationSuspension({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationPeriodService.liftBusinessRegistrationSuspension(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setPeriods(state, newState) {
      state.periods = newState;
    },
    setSuspensions(state, newState) {
      state.suspensions = newState;
    },
  },
};
